export default {
    methods: {
        async filterRole(roleId, roleIds, storeId, option, type) {
            // 1-超级管理员，2-店长，3-财务，4-前台，5-会籍销售经理，6-会籍销售
            // 7-私教经理，8-私教教练，9-团课经理，10-团课教练
            console.log(roleId);
            let form;
            const op = option ? option : 'or';
            if (roleId) form = { roleId: roleId, storeId: storeId, option: op };
            else if (roleIds) form = { roleIds: roleIds.join(','), storeId: storeId, option: op };
            else if (!roleId && !roleIds && storeId) form = { storeId: storeId };

            let data;
            await API.get('staff/list', {
                params: form,
            }).then(res => {
                if (type) data = res.filter(el => !el.isResigned);
                else data = res;
            });
            return data;
        },
    },
};
